/* istanbul ignore file */
import _ from 'lodash'
import type { Maybe } from '@adc/sdk/types'
import type { AuctionBlueprintValidationResult } from '@adc/blueprint'
import * as graph from '@adc/sdk'
import * as blueprint from '@adc/blueprint'
import { Question, validValidation } from '.'
import { LeadIntake } from './stepManager'
// NOTE: We won't need this on a newer version of typescript
type MaybeObjectThen = object & {
  then: Maybe<unknown>
}
type ValidationStore = Record<string, string>

// NOTE: These are wicked handy. Should we have a utility type library or whack it into adc/sdk/promise/types?
function isPromise<T = unknown>(val: unknown): val is Promise<Awaited<T>> {
  return (
    Boolean(val) &&
    (typeof val === 'object' || typeof val === 'function') &&
    typeof (val as MaybeObjectThen).then === 'function'
  )
}

function isPromiseFulfilled<T>(
  val: PromiseSettledResult<T>
): val is PromiseFulfilledResult<T> {
  return val.status === 'fulfilled'
}

// Return true when has errors
//
// NOTE: From Connor, this doesn't read all that great tbh. Is it ever valid tofr questions to be empty?

export const validateCurrent = async (
  answers: Record<string, string>,
  questions?: Question[]
) => {
  if (!questions || _.isEmpty(questions)) {
    return { hasErrors: false, nextValidations: null }
  }

  const executors = await Promise.allSettled(
    questions.map(({ field, validate }) => {
      const nextValidation = validate?.(answers) || validValidation

      return isPromise<AuctionBlueprintValidationResult>(nextValidation)
        ? nextValidation.then(result => ({ field, nextValidation: result }))
        : { field, nextValidation }
    })
  )

  const [fulfilled, rejected] = _.partition(executors, isPromiseFulfilled)
  const hasErrors =
    !_.isEmpty(rejected) || fulfilled.some(ex => !ex.value.nextValidation.valid)

  const nextValidations = executors.reduce((acc, ex) => {
    if (!isPromiseFulfilled(ex)) return acc

    if (answers[ex.value.field] !== undefined) {
      acc[ex.value.field] = ex.value.nextValidation.message
    }

    return acc
  }, {} as ValidationStore)

  return { hasErrors, nextValidations }
}

export type LeadIntakeType = Record<string, any>

export const getInitialLeadIntake = (
  user: blueprint.primitives.AuctionUser,
  address?: Record<string, any>
): Partial<LeadIntakeType> => {
  let userFields: Partial<LeadIntakeType> = {}

  const propertyFields: LeadIntake = {
    property: {
      program_type: graph.enums.LeadIntakeProgramType.SellWithUs,
      property_type: undefined,
    },
  }

  if (user?.logged_in) {
    const phones = user.party?.phones
    const phone = phones && phones[0]?.number
    userFields = {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phone,
      __computed__: { logged_in: user.logged_in },
    }
  }
  return { ...userFields, ...propertyFields, ...address }
}
